module.exports = __webpack_public_path__ + "img/banner2CN.7a6f7c77.png";